import React from 'react';

import { ActionIcon, Icon, TFNotifier, Tooltip } from '@tf/ui';

import { downloadFile, type FileInfo } from '../../../../api/files';

interface PreviewButtonProps {
	file: FileInfo;
}

export const PreviewButton: React.FC<PreviewButtonProps> = ({ file }) => {
	const handlePreview = React.useCallback(async () => {
		try {
			const blob = await downloadFile(file.id);
			const url = URL.createObjectURL(blob);
			window.open(url, '_blank');
			URL.revokeObjectURL(url);
		} catch (e) {
			console.error('Preview failed:', e);
			TFNotifier.error('File preview failed', {
				id: 'PreviewError',
			});
		}
	}, [file.id]);

	return (
		<Tooltip label="Preview document" withArrow>
			<ActionIcon variant="subtle" color="blue" onClick={handlePreview}>
				<Icon.IconEye size={18} stroke={1.5} />
			</ActionIcon>
		</Tooltip>
	);
};
